import { createContext } from "react";

export default createContext<{ totalWidth: number; totalHeight: number }>({
  totalWidth: 100,
  totalHeight: 100,
});
